import { track } from '@sloyd/analytics';
import * as api from '@sloyd/api';
import { selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { prompt } from '@sloyd/ui';
import { useMemo, useState } from 'react';
import { invokeEvent } from 'shared-base';
import { ContentAccount } from './ContentAccount';

export type ContentAccountContainerProps = {};

export function ContentAccountContainer(_props: ContentAccountContainerProps) {
  const dispatch = useDispatch();
  const user = useSelector(selectors.base.$user);
  const account = useSelector(selectors.base.$account);
  const [isPaddlePortalLoading, setIsPaddlePortalLoading] = useState(false);

  const callbacks = useMemo(
    () => ({
      onChange: (_change: Json, allData: Json) => {},
      onNavigate: (path: string) => {
        invokeEvent('nav', { path });
      },
      buy10Credits: () => {
        dispatch({ type: 'PURCHASE', verb: 'credits' });
      },
      onPaddlePortal: async () => {
        try {
          track('Manage Subscription');

          setIsPaddlePortalLoading(true);
          const res = await api.user.createPaddleCustomerPortal();
          if (!res.isSuccess) {
            prompt.confirm({
              title: 'Issue with Customer Portal',
              description:
                'There seems to be an issue with the subscriptions portal 🙏. Please email us at support@sloyd.ai to manage your subscription.',
              ctaButtonText: 'Got it',
              hideCancel: true,
            });
            setIsPaddlePortalLoading(false);
            return;
          }
          window.location.href = res.data as string;
        } catch (err) {
          console.log('err =>', err);
        }

        setIsPaddlePortalLoading(false);
      },
      onGenerateApiKey: () => {
        dispatch({ type: 'GENERATE_API_KEY' });
      },
    }),
    []
  );

  return (
    <ContentAccount
      user={user}
      account={account}
      isPaddlePortalLoading={isPaddlePortalLoading}
      callbacks={callbacks}
    />
  );
}

export default ContentAccountContainer;
